(function () {
  const root = document.querySelector(".npw-wrench");
  if (!root) return;
  const api = (root.getAttribute("data-api") || "https://api.npower.com.vn").replace(/\/$/, "");
  const $ = (sel) => root.querySelector(sel);

  const FALLBACK_HEADS = [
    { code: "hex", name_vi: "Lục giác ngoài", name_en: "External hex", tool_vi: "Cờ lê / tuýp" },
    { code: "allen", name_vi: "Lục giác trong", name_en: "Hex socket", tool_vi: "Imbus" },
    { code: "torx", name_vi: "Hoa thị", name_en: "Torx", tool_vi: "Hoa thị" }
  ];
  const FALLBACK_THREADS = ["M3","M4","M5","M6","M8","M10","M12","M14","M16","M18","M20","M22","M24","M27","M30","M33","M36","M39","M42","M45","M48"];
  const FALLBACK_INCH = ["1/4","5/16","3/8","7/16","1/2","9/16","5/8","3/4","7/8","1"];

  let heads = FALLBACK_HEADS.slice();
  let threads = FALLBACK_THREADS.map((t) => ({ thread: t, system: "metric" }));
  let head = "hex";
  let system = "metric";
  let lastCopy = "";

  async function getJson(path) {
    const res = await fetch(api + path, { headers: { Accept: "application/json" } });
    const data = await res.json();
    if (!res.ok && !data) throw new Error("HTTP " + res.status);
    return data;
  }

  function badgeCls(cls) {
    return cls === "lookup" || cls === "std" ? "npw-wrench__tag--ok" : "npw-wrench__tag--note";
  }

  function fillSys() {
    const box = $("[data-sys]");
    if (!box) return;
    box.querySelectorAll("[data-system]").forEach((b) => {
      b.classList.toggle("on", b.getAttribute("data-system") === system);
      b.onclick = () => {
        system = b.getAttribute("data-system");
        const hint = root.querySelector(".npw-wrench__hint");
        if (hint) {
          hint.textContent = system === "inch"
            ? "Cờ lê inch theo ASME B18.2.1 (regular hex). 1/2 in → tuýp 3/4 in, không lấy 16 mm."
            : "M10 / M12 trên thị trường VN có thể lệch ISO và DIN cũ. Đo 2 cạnh đầu ốc.";
        }
        fillSys();
        fillSize();
        run();
      };
    });
  }

  function fillTabs() {
    $("[data-tabs]").innerHTML = heads.map((h) =>
      `<button type="button" class="npw-wrench__tab${h.code === head ? " on" : ""}" data-head="${h.code}">${h.name_vi} <span class="npw-wrench__en">/ ${h.name_en}</span></button>`
    ).join("");
    $("[data-tabs]").querySelectorAll("[data-head]").forEach((b) => {
      b.onclick = () => {
        head = b.getAttribute("data-head");
        fillTabs();
        fillSize();
        run();
      };
    });
  }

  function fillSize() {
    const el = $("[data-size]");
    const prev = el.value;
    const list = threads.filter((t) => (!t.head || t.head === head) && (!t.system || t.system === system));
    const fallback = system === "inch" ? FALLBACK_INCH : FALLBACK_THREADS;
    const names = list.length ? list.map((t) => t.thread) : fallback;
    const uniq = [...new Set(names)];
    el.innerHTML = uniq.map((t) => `<option value="${t}">${t}</option>`).join("");
    if (uniq.includes(prev)) el.value = prev;
    else if (system === "inch" && uniq.includes("1/2")) el.value = "1/2";
    else if (uniq.includes("M10")) el.value = "M10";
    else if (uniq[0]) el.value = uniq[0];
  }

  function paint(out) {
    if (!out || !out.ok) {
      $("[data-fromto]").textContent = "Không tra được";
      $("[data-amp]").textContent = "—";
      $("[data-alt]").textContent = "";
      $("[data-tags]").innerHTML = "";
      $("[data-notice]").innerHTML = `<div class="npw-wrench__warn">${(out && out.error && out.error.message) || "Lỗi API"}</div>`;
      $("[data-tbody]").innerHTML = "";
      $("[data-cite]").textContent = "";
      lastCopy = "";
      return;
    }
    const iso = out.primary || {};
    const din = out.din_old;
    const differ = !!(din && iso.value_mm != null && din.value_mm != null && Number(iso.value_mm) !== Number(din.value_mm));
    const codes = [...new Set((out.rows || []).map((r) => r.value_code).filter(Boolean))].sort((a, b) => {
      const na = parseInt(String(a).replace(/\D/g, ""), 10);
      const nb = parseInt(String(b).replace(/\D/g, ""), 10);
      if (Number.isFinite(na) && Number.isFinite(nb) && na !== nb) return na - nb;
      return String(a).localeCompare(String(b), "vi");
    });
    const toolTxt = codes.length > 1 ? codes.join(" hoặc ") : (codes[0] || iso.value_code || "—");
    const verb = head === "torx" ? "mở bằng khoá số " : (head === "allen" ? "mở bằng imbus " : "mở bằng cờ lê / tuýp ");
    $("[data-fromto]").textContent = (iso.head_vi || head) + " · " + out.thread + " " + verb + toolTxt;
    $("[data-amp]").textContent = toolTxt;
    $("[data-alt]").textContent = differ
      ? ("ISO 272: " + iso.value_code + " · DIN cũ: " + din.value_code)
      : (codes.length > 1
          ? ("Thị trường gặp " + toolTxt + " — xem tem / đo ổ trước khi mua bit.")
          : (out.system === "inch"
              ? ((iso.code || "ASME") + " · " + (iso.value_code || ""))
              : (head === "hex" ? ("ISO 272 = DIN cũ = " + (iso.value_code || "")) : (iso.tool_vi || ""))));
    $("[data-tags]").innerHTML = (out.badges || []).map((b) =>
      `<span class="npw-wrench__tag ${badgeCls(b.class)}">${b.label}</span>`
    ).join("");
    let html = "";
    (out.warnings || []).forEach((w) => {
      html += `<div class="npw-wrench__warn">${w.message}</div>`;
    });
    if (iso.standard_notes) html += `<div class="npw-wrench__meta">${iso.standard_notes}</div>`;
    $("[data-notice]").innerHTML = html;
    $("[data-tbody]").innerHTML = (out.rows || []).map((r) =>
      `<tr><td>${r.series}</td><td class="m">${r.value_code || "—"}</td><td>${r.class_tag === "lookup" ? "THEO TIÊU CHUẨN" : (r.class_tag === "cat" ? "THAM CHIẾU" : r.class_tag)}</td></tr>`
    ).join("");
    const cite = [iso.org, iso.code, iso.edition, iso.eq_org, iso.eq_code].filter(Boolean).join(" · ");
    $("[data-cite]").textContent = cite;
    const lines = [
      "NPOWER — Chọn cờ lê / lục giác / hoa thị",
      out.thread + " · " + (iso.head_vi || head) + (out.system === "inch" ? " · inch" : " · metric"),
      verb + toolTxt,
      cite,
      "Nguồn thông tin từ NPOWER | NAVITECH :: npower.com.vn | navitech.co"
    ];
    (out.warnings || []).forEach((w) => lines.push(w.message));
    lastCopy = lines.join("\n");
  }

  async function run() {
    const thread = $("[data-size]").value;
    try {
      const out = await getJson("/api/engineering/fastener/wrench?thread=" + encodeURIComponent(thread) + "&head=" + encodeURIComponent(head) + "&system=" + encodeURIComponent(system));
      paint(out);
    } catch (err) {
      paint({ ok: false, error: { message: "Lỗi mạng / CORS: " + err.message } });
    }
  }

  async function boot() {
    fillSys();
    fillTabs();
    fillSize();
    try {
      const meta = await getJson("/api/engineering/fastener/meta");
      if (meta && meta.ok) {
        if (meta.heads && meta.heads.length) heads = meta.heads;
        if (meta.threads && meta.threads.length) threads = meta.threads;
        fillTabs();
        fillSize();
      }
    } catch (e) { /* fallback */ }
    $("[data-size]").addEventListener("change", run);
    const copyBtn = $("[data-copy]");
    if (copyBtn) {
      copyBtn.addEventListener("click", async () => {
        try { await navigator.clipboard.writeText(lastCopy || location.href); } catch (e) {}
        copyBtn.textContent = "Đã sao chép";
        setTimeout(() => { copyBtn.textContent = "Sao chép kết quả"; }, 1600);
      });
    }
    const wrap = root.querySelector(".npw-wrench__sharewrap");
    const menu = root.querySelector(".npw-wrench__sharemenu");
    const shareBtn = $("[data-share]");
    if (wrap && menu && shareBtn) {
      menu.removeAttribute("hidden");
      function closeShare() { wrap.classList.remove("is-open"); }
      function openShare() { wrap.classList.add("is-open"); }
      shareBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (wrap.classList.contains("is-open")) closeShare();
        else openShare();
      });
      wrap.addEventListener("click", (e) => e.stopPropagation());
      document.addEventListener("click", closeShare);
      menu.querySelectorAll("[data-share-kind]").forEach((btn) => {
        btn.addEventListener("click", async (e) => {
          e.preventDefault();
          e.stopPropagation();
          const kind = btn.getAttribute("data-share-kind");
          const url = location.href.split("#")[0];
          const text = lastCopy || document.title;
          closeShare();
          if (kind === "system") {
            if (navigator.share) {
              try { await navigator.share({ title: document.title, text, url }); } catch (err) {}
            } else {
              try { await navigator.clipboard.writeText(text + "\n" + url); } catch (err) {}
            }
          } else if (kind === "facebook") {
            window.open("https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(url), "_blank", "noopener");
          } else if (kind === "email") {
            location.href = "mailto:?subject=" + encodeURIComponent("NPOWER — cỡ cờ lê") + "&body=" + encodeURIComponent(text + "\n" + url);
          } else if (kind === "whatsapp") {
            window.open("https://wa.me/?text=" + encodeURIComponent(text + "\n" + url), "_blank", "noopener");
          } else if (kind === "link") {
            try { await navigator.clipboard.writeText(url); } catch (err) {}
          }
        });
      });
    }
    run();
  }

  boot();
})();
